import { render, staticRenderFns } from "./RosaPage.vue?vue&type=template&id=730ef943&scoped=true&"
import script from "./RosaPage.vue?vue&type=script&lang=js&"
export * from "./RosaPage.vue?vue&type=script&lang=js&"
import style0 from "./RosaPage.vue?vue&type=style&index=0&id=730ef943&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730ef943",
  null
  
)

export default component.exports